import Indicator, { IndicatorType } from '../../types/Indicator'

const Major: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'major',
  label: 'Major',
  fields: ['redMajor', 'greenMajor'],
}

export default Major
